function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 51.7499,
  height: 50,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4166_7067)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.95217 41.6666C8.95957 41.6666 8.13086 41.3454 7.46601 40.703C6.80117 40.0607 6.46875 39.26 6.46875 38.301V17.9489C6.46875 16.9898 6.80117 16.1892 7.46601 15.5468C8.13086 14.9044 8.95957 14.5833 9.95217 14.5833H19.4062V11.6984C19.4062 10.7397 19.7387 9.93915 20.4035 9.29679C21.0683 8.65443 21.8971 8.33325 22.8897 8.33325H28.8603C29.8529 8.33325 30.6816 8.65443 31.3465 9.29679C32.0113 9.93915 32.3437 10.7397 32.3437 11.6984V14.5833H41.7978C42.7904 14.5833 43.6191 14.9044 44.2839 15.5468C44.9488 16.1892 45.2812 16.9898 45.2812 17.9489V26.6947C44.9384 26.4836 44.5943 26.2999 44.2489 26.1437C43.9032 25.9874 43.5285 25.8412 43.125 25.7051V17.9489C43.125 17.5749 43.0006 17.2676 42.7519 17.027C42.5029 16.7867 42.1848 16.6666 41.7978 16.6666H9.95217C9.56512 16.6666 9.24707 16.7867 8.99803 17.027C8.74934 17.2676 8.625 17.5749 8.625 17.9489V38.301C8.625 38.6749 8.74934 38.9822 8.99803 39.2228C9.24707 39.4631 9.56512 39.5833 9.95217 39.5833H26.0367C26.1168 39.9652 26.2025 40.3232 26.2938 40.6572C26.3851 40.9909 26.4956 41.3273 26.6254 41.6666H9.95217ZM21.5625 14.5833H30.1875V11.6984C30.1875 11.3247 30.0631 11.0176 29.8144 10.777C29.5654 10.5367 29.2473 10.4166 28.8603 10.4166H22.8897C22.5026 10.4166 22.1846 10.5367 21.9355 10.777C21.6868 11.0176 21.5625 11.3247 21.5625 11.6984V14.5833ZM38.8125 45.8333C36.41 45.8333 34.372 45.0246 32.6984 43.4072C31.0245 41.7902 30.1875 39.8211 30.1875 37.4999C30.1875 35.1787 31.0245 33.2096 32.6984 31.5926C34.372 29.9753 36.41 29.1666 38.8125 29.1666C41.2149 29.1666 43.2529 29.9753 44.9265 31.5926C46.6005 33.2096 47.4375 35.1787 47.4375 37.4999C47.4375 39.8211 46.6005 41.7902 44.9265 43.4072C43.2529 45.0246 41.2149 45.8333 38.8125 45.8333ZM39.6415 37.1635V31.4905H37.9834V37.8364L42.3703 42.0754L43.5481 40.9374L39.6415 37.1635Z",
  fill: "#1C1B1F"
}));

function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4166_7067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 50
  }, _ref2), _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.29a0b3fb19bf4fed1a0a85ef35717c5a.svg";
export { ForwardRef as ReactComponent };